import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import SmartphoneOutlinedIcon from '@mui/icons-material/SmartphoneOutlined';
import DesignServicesOutlinedIcon from '@mui/icons-material/DesignServicesOutlined';
import BrushOutlinedIcon from '@mui/icons-material/BrushOutlined';
import MemoryOutlinedIcon from '@mui/icons-material/MemoryOutlined';

const services = [
    {
        id: 1,
        title: 'Web Site Development',
        description: 'Custom websites tailored to your business needs, ensuring a strong online presence.',
        icon: <LanguageOutlinedIcon fontSize="large" />,
        features: [
            'Responsive Design',
            'SEO Friendly',
            'E-commerce Solutions',
            'Content Management'
        ],
        category: 'development'
    },
    {
        id: 2,
        title: 'CRM Solutions',
        description: 'Streamline your business processes and manage customer relationships efficiently.',
        icon: <BusinessCenterOutlinedIcon fontSize="large" />,
        features: [
            'Lead Management',
            'Sales Automation',
            'Customer Support',
            'Analytics & Reporting'
        ],
        category: 'development'
    },
    {
        id: 3,
        title: 'Mobile Applications',
        description: 'Native and cross-platform mobile apps for iOS and Android to engage your customers.',
        icon: <SmartphoneOutlinedIcon fontSize="large" />,
        features: [
            'iOS & Android',
            'Cross-platform',
            'Push Notifications',
            'App Store Deployment'
        ],
        category: 'development'
    },
    {
        id: 4,
        title: 'UI/UX Design',
        description: 'Intuitive and visually appealing user interfaces for web and mobile applications.',
        icon: <DesignServicesOutlinedIcon fontSize="large" />,
        features: [
            'User Research',
            'Wireframing',
            'Prototyping',
            'Usability Testing'
        ],
        category: 'design'
    },
    {
        id: 5,
        title: 'Graphic Design',
        description: 'Creative graphic design solutions for branding, marketing, and digital assets.',
        icon: <BrushOutlinedIcon fontSize="large" />,
        features: [
            'Logo Design',
            'Brand Identity',
            'Marketing Materials',
            'Social Media Graphics'
        ],
        category: 'design'
    },
    {
        id: 6,
        title: 'AI ML Solution',
        description: 'Leverage artificial intelligence and machine learning to drive innovation and efficiency.',
        icon: <MemoryOutlinedIcon fontSize="large" />,
        features: [
            'Predictive Analytics',
            'Automation',
            'Data Insights',
            'Custom AI Models'
        ],
        category: 'analytics'
    }
];

export default services; 